// ============================================================================
// SWAHILI TRANSLATIONS - UI
// ============================================================================

import unityTranslations from './unity.js';
export const uiTranslations = {
  meta: {
    language: 'sw',
    languageName: 'Kiswahili',
    version: '1.0'
  },
  
  app: {
    title: "UNITYQUEST Hadithi\nya Upendo",
    subtitle: "Ugunduzi wa Maandiko wa Kuingiliana",
    tagline: "Kutembea kuelekea mwanga wa kimungu",
    menu: "Menyu",
    retry: "Jaribu tena"
  },
  
  buttons: {
    play: "CHEZA",
    back: "Rudi",
    continue: "Endelea",
    restart: "Anzisha upya",
    close: "Funga",
    nextLevel: "Ngazi inayofuata",
    selectLevel: "Uchaguzi wa ngazi",
    retry: "Jaribu tena",
    mainMenu: "Menyu kuu",
    start: "Anza",
    cancel: "Ghairi",
    confirm: "Thibitisha",
    save: "Hifadhi",
    load: "Pakia",
    yesRestart: "Ndiyo, anzisha upya",
    noContinue: "Hapana, endelea",
    tryAgain: "Jaribu tena",
    backToMenu: "Rudi kwenye menyu"
  },
  
  labels: {
    score: "Alama",
    stars: "Nyota",
    wisdom: "Hekima",
    revelation: "Ufunuo",
    lives: "Maisha",
    combo: "Combo",
    level: "NGAZI",
    easy: "RAHISI",
    medium: "WASTANI",
    hard: "NGUMU",
    correct: "Sahihi!",
    gameOver: "Jaribio limeshindwa",
    victory: "Ushindi!",
    completed: "Imekamilika",
    rank: "Daraja la kiroho",
    points: "Pointi za hekima",
    unlockedLevels: "ngazi zilizofunguliwa",
    questionOfKnowledge: "Swali la maarifa",
    hintOfWisdom: "Kidokezo cha hekima",
    knowledgeMastered: "Maarifa yameshindwa!",
    knowledgeAcquired: "Maarifa yamepatikana!",
    testFailed: "Jaribio limeshindwa",
    wisdomBonus: "Bonus",
    xpGained: "XP",
    newRank: "Daraja jipya"
  },
  
  menu: {
    playButton: "CHEZA",
    info: "Habari",
    treasures: "Hazina",
    john: "Yohana",
    reset: "Rudisha",
    restart: "🔄 Anzisha tena safari?",
    confirmReset: "Je, una uhakika unataka kufuta maendeleo yako yote?",
    youWillLose: "Utapoteza:",
    wisdomPoints: "Pointi za hekima",
    starsCollected: "nyota zilizokusanywa",
    levelsUnlocked: "ngazi zilizofunguliwa",
    spiritualRank: "Daraja la kiroho",
    newAdventure: "🎮 Safari mpya",
    readyToStart: "Uko tayari kuanza?",
    startJourney: "Anza safari yako katika maarifa ya Maandiko!",
    audioControls: "Vidhibiti vya sauti",
    mute: "Zima sauti",
    unmute: "Washa sauti",
    close: "Funga",
    language: "Lugha",
    restartGame: "Anzisha upya mchezo"
  },
  
  login: {
    title: "UNITY QUEST",
    subtitle: "Safari ya Biblia ya kuingiliana",
    anonymousMode: "Cheza Bila Jina",
    anonymousDesc: "Chagua jina la utani",
    emailMode: "Ingia kwa Barua pepe",
    emailDesc: "Uhifadhi wa vifaa vingi",
    pseudo: "Jina la utani",
    pseudoPlaceholder: "Jina lako la utani...",
    email: "Anwani ya Barua pepe",
    emailPlaceholder: "barua@yako.com",
    startPlaying: "Anza kucheza",
    sendLink: "Tuma kiungo",
    sending: "Inatuma...",
    connecting: "Inaunganisha...",
    back: "Rudi",
    localSave: "Maendeleo yako yatahifadhiwa kimtandao",
    cloudSync: "Hakuna nenosiri linalohitajika • Usawazishaji wa wingu",
    magicLink: "Pokea kiungo cha ajabu kwa barua pepe",
    checkEmail: "✉️ Angalia barua pepe yako! Kiungo cha kuingia kimetumwa.",
    checkSpam: "Angalia pia folda yako ya spam/barua zisizotakiwa",
    waitingConnection: "Inasubiri muunganisho...",
    errorSend: "Kosa la kutuma kiungo",
    rateLimited: "⏳ Tafadhali subiri sekunde 15 kabla ya kutuma barua pepe tena",
    importSession: "🔄 Leta kipindi kutoka kwa uzalishaji",
    errorConnection: "Kosa la muunganisho",
    enterPseudo: "Tafadhali weka jina la utani",
    enterEmail: "Tafadhali weka barua pepe halali",
    // Tooltips
    never: "Kamwe",
    save: "Hifadhi mchezo",
    lastSave: "mwisho",
    refresh: "Pakia tena maendeleo",
    logout: "Ondoka",
    connectToCloud: "Unganisha kuhifadhi mtandaoni",
    editPseudo: "Hariri jina la mtumiaji",
    confirm: "Thibitisha",
    cancel: "Ghairi",
    close: "Funga",
    passwordMode: "Kuingia Rahisi",
    passwordDesc: "Barua pepe + nywila",
    password: "Nywila",
    passwordPlaceholder: "Angalau herufi 6",
    passwordMinLength: "Angalau herufi 6",
    playWithoutAccount: "Cheza bila akaunti",
    forgotPassword: "Umesahau nenosiri?",
    resetPasswordTitle: "Weka Upya Nenosiri",
    resetPasswordSubtitle: "Ingiza barua pepe yako kupokea kiungo cha kuweka upya",
    sendResetLink: "Tuma Kiungo",
    resetEmailSent: "📧 Barua pepe ya kuweka upya imetumwa! Angalia sanduku lako la barua.",
    errorReset: "Hitilafu ya kutuma barua pepe",
    backToSignin: "Rudi kwenye Kuingia",
    newPassword: "Nenosiri Jipya",
    enterNewPassword: "Chagua nenosiri jipya salama",
    confirmPassword: "Thibitisha Nenosiri",
    updatePassword: "Sasisha Nenosiri",
    passwordsDontMatch: "Nenosiri hazilingani",
    passwordUpdateSuccess: "✅ Nenosiri limesasishwa kwa mafanikio!",
    errorUpdatePassword: "Hitilafu ya kusasisha nenosiri",
    resetLinkExpired: "Kiungo cha kuweka upya kimeisha muda au si sahihi",
    forgotPassword: "Umesahau nenosiri?",
    signup: "Jiandikishe",
    signin: "Ingia",
    createAccount: "Unda Akaunti",
    signupInfo: "Jaza fomu iliyo hapa chini",
    passwordInfo: "Upatikanaji wa haraka na nywila",
    signupButton: "Unda Akaunti Yangu",
    signinButton: "Ingia",
    passwordTooShort: "Nywila lazima iwe na angalau herufi 6",
    emailAlreadyExists: "Barua pepe hii tayari inatumika",
    emailExistsHint: "✉️ Barua pepe hii tayari imesajiliwa. Jaribu kuingia! (Labda iliundwa kutoka kwa mchezo mwingine?)",
    switchToSignin: "🔑 Badili hadi njia ya kuingia kwa barua pepe yako iliyopo",
    invalidCredentials: "Barua pepe au nywila si sahihi",
    signupSuccess: "📧 Akaunti imeundwa! Angalia barua pepe yako kuhakikisha usajili wako.",
    emailConfirmationRequired: "Angalia kisanduku chako cha barua kupata ili kuamilisha akaunti yako",
    checkSpamFolder: "Kumbuka kuangalia folda yako ya spam/barua zisizohitajika",
    connectionSuccess: "✅ Umeingia kwa mafanikio!",
    errorSignup: "Hitilafu wakati wa kujiandikisha"},
  
  install: {
    title: "Sakinisha programu",
    subtitle: "Ufikiaji wa haraka na nje ya mtandao",
    feature1: "Uzinduzi wa papo hapo kutoka kwa skrini yako ya nyumbani",
    feature2: "Inafanya kazi nje ya mtandao baada ya usakinishaji",
    feature3: "Uzoefu wa programu asilia",
    feature4: "Hakuna upakuaji wa duka unahitajika",
    install: "Sakinisha",
    dismiss: "Baadaye",
    info: "Unaweza kuondoa programu wakati wowote"
  },
  
  ranks: {
    seeker: "Mtafutaji",
    believer: "Aliyeamka",
    disciple: "Mwanafunzi",
    servant: "Mtumishi",
    witness: "Shahidi",
    guardian: "Mlinzi",
    wise: "Mwenye hekima",
    prophet: "Nabii",
    apostle: "Mtume",
    seekerDesc: "Mwanzo wa safari ya kiroho",
    believerDesc: "Fahamu ya kiroho iliyoamka",
    discipleDesc: "Kujifunza mafundisho",
    servantDesc: "Huduma na utii",
    witnessDesc: "Kushiriki imani",
    guardianDesc: "Ulinzi wa ukweli",
    wiseDesc: "Hekima na maarifa",
    prophetDesc: "Maono ya kiroho",
    apostleDesc: "Mwalimu wa kiroho"
  },

  spiritualJourney: {
    beginning: "Mwanzo wa safari ya kiroho",
    progress: "Maendeleo ya kiroho",
    grade: "Daraja",
    xp: "XP",
    level: "Kiwango",
    nextGrade: "Daraja linalofuata",
    still: "Bado",
    maxLevelReached: "Kiwango cha Juu Kimefikiwa!",
    masteredAllTeachings: "Umejifunza mafundisho yote",
    progression: "Maendeleo"
  },
  
  treasures: {
    title: "💎 Hazina za Biblia",
    verse: "Aya ya siku",
    fact: "Je, ulijua?",
    treasure: "Hazina iliyofichwa",
    question: "Swali la kuchekesha",
    context: "Muktadha",
    strongReference: "Rejea ya Biblia kwa masomo ya kina",
    emmanuelMemo: "Kumbukumbu ya Emmanuel",
    emmanuelMessage: "Umefika juu ya mlima, na maarifa yamepatikana. Lakini imani isiyoyumbayumba inahitaji uzoefu wa maisha, rehema na upendo wa kweli wa Yesu. Majaribu mbalimbali ya maisha yatajaribu njia yako, njia ya kweli tunayochagua, moyo wetu. Tunabaki wasio kamilifu, tamaa zetu ni nyingi, na upendo wa faida au starehe yetu binafsi mara nyingi unakuwa kipaumbele chetu cha ubinafsi. Muombe Mungu hekima, upendo wake, nguvu zake, na ukubali kwa unyenyekevu udhaifu wako, kwa sababu hakuna kinachoweza kufichwa Mbele yake... Hakuna kitu. Hakuna haja ya kusafiri katika hali ya faragha, VPN, au hata kufuta historia. Funga kama Danieli: jinyime kwa muda wa kile unachokipenda zaidi, katika utulivu na hekima. Hii itakuruhusu kusikia Mungu vizuri zaidi, kuwa na tabia ya moyo iliyojiandaa kwa mabadiliko ya kina — na mara nyingi ya maumivu. Kisha ndoto na maono yatakuwa wazi zaidi, kama kwa Yosefu. Lakini jihadhari na kiburi: usikubali 'nina haki daima' au 'najua vizuri zaidi'. Kwa sababu ufunuo wa Mungu ni neema ya ajabu. Usikuwe daktari wa Sheria, mwenye uwezo wa kumsulubisha Yesu tena leo, Yeye ambaye anaomba tu kupenda jirani yako... na kumpa uhuru sawa na ule unaopokea. Kuwa na imani ni kuingia katika uhusiano na safari ya moyo iliyo huru. Itakufanya mashujaa wenye nguvu, wenye uwezo wa mambo yasiyo ya kawaida. Kwa sababu uzoefu wa kimiujiza, uwepo wa Mungu, uthibitisho wake au baraka zake zitakufanya usiyumbayumba kweli.",
    clarification: "Ufafanuzi muhimu",
    bibleOffline: "Soma Biblia Bila mtandao",
    bibleStudy: "Masomo ya Biblia",
    version: "Toleo",
    openReader: "Fungua kisomaji",
    features: "Vipengele"
  },
  
  messages: {
    chooseCard: "⚡ Chagua kadi yako ya nguvu",
    cardHelp: "Itakufuata kwa maswali 3 ya ngazi hii",
    chooseAnswer: "📖 Chagua jibu lako:",
    wrongAnswer: "❌ Jibu lisilo sahihi! Umebaki na maisha {lives}. Jaribu tena!",
    levelCompleted: "Ngazi {level} imekamilika",
    questionsProgress: "Swali {current} kati ya {total}",
    starsCollected: "Nyota zilizokusanywa: {current}/{total}",
    pointsEarned: "+{points} pointi za hekima",
    secondChance: "⚔️ Kadi yako ya UJASIRI inakupa nafasi ya pili! Jaribu tena kwa hekima.",
    bonusApplied: "✨ Bonus ya {card}: +{percent}% ({base} → {final})",
    defeatedQuote: "Naweza mambo yote ndani Yake",
    perfect: "✨ Kamili",
    good: "⭐ Vizuri",
    start: "⭐ Mwanzo",
    secretLevel: "🎺 NGAZI YA SIRI IMEFUNGULIWA!",
    secretChapter: "🏆 Sura ya siri",
    returnToLevels: "Rudi",
    next: "Inayofuata",
    retry: "Jaribu tena",
    menu: "Menyu",
    chapter: "Sura",
    chapterStars: "Nyota za sura",
    totalGlobal: "Jumla ya ulimwengu",
    backToMenu: "Rudi kwenye menyu"
  },
  
  chapters: {
    "1": "Mwanzo",
    "2": "Kutoka",
    "3": "Yesu Kristo",
    "4": "Kusulubiwa/Ufufuo",
    "5": "Kanisa la awali",
    "6": "Misheni ya Paulo",
    "7": "Barua/Ufunuo",
    "8": "Ngazi ya ziada"
  },
  
  cards: {
    faith: "IMANI",
    courage: "UJASIRI",
    wisdom: "HEKIMA",
    faithKnowledge: "+50% pointi",
    courageKnowledge: "Nafasi ya pili",
    wisdomKnowledge: "Kidokezo + bonus",
    faithDesc: "Upeo wa pointi za hekima zilizopatikana",
    courageDesc: "Pointi za kawaida lakini nafasi ya pili",
    wisdomDesc: "Kidokezo kilichofunuliwa na +25% pointi",
    chooseCard: "✨ Chagua kipaji cha maarifa",
    cardEffects: "✨ Athari za vipaji vya maarifa:",
    faithEffect: "+50% pointi za hekima - Tuzo ya juu zaidi",
    courageEffect: "Pointi za kawaida lakini nafasi ya pili wakati wa kosa",
    wisdomEffect: "+25% pointi + kidokezo kilichofunuliwa kwa kila swali",
    chooseWisely: "Chagua kwa hekima, kwa sababu chaguo lako litakufuata katika ngazi yote"
  },
  
  challenge: {
    loading: "Inapakia ngazi...",
    peace: "🕊️ Amani itue nyumbani kwako",
    questionsAwaiting: "💡 Maswali 3 ya maarifa yanakungoja",
    starsQuote: "Kila nyota ni hatua kuelekea mwanga wa kimungu"
  },
  
  info: {
    title: "Unity Quest Kumbukumbu za Amani",
    subtitle: "Ugunduzi wa Maandiko wa kuingiliana",
    yourStats: "Takwimu zako",
    score: "Alama",
    wisdom: "Hekima",
    revelation: "Ufunuo",
    createdWith: "Imeundwa na ❤️",
    creator: "Emmanuel Payet",
    developerPassionate: "Msanidi programu mwenye shauku ya kiroho",
    artistModule: "Emmanuel Msanii",
    artistPortfolio: "Portfolio ya sanaa na ubunifu wa kidijitali",
    features: "Vipengele",
    multipleChapters: "Ngazi 91 katika sura 8 za Biblia",
    powerCards: "Kadi 3 za pekee za nguvu (Imani, Ujasiri, Hekima)",
    progressionSystem: "Mfumo wa maendeleo na daraja la kiroho",
    bibleTreasures: "Hazina za Biblia na ukweli wa kuvutia",
    howToPlay: "Jinsi ya kucheza",
    selectLevel: "Chagua ngazi iliyofunguliwa",
    choosePowerCard: "Chagua kadi yako ya nguvu",
    answerQuestions: "Jibu maswali 3 ya maarifa",
    earnStars: "Pata nyota kulingana na maisha yaliyobaki",
    tips: "Vidokezo",
    readCarefully: "Soma kila swali kwa makini",
    useWisdomCard: "Tumia kadi ya Hekima kwa vidokezo",
    courageGivesSecondChance: "Kadi ya Ujasiri inakupa nafasi ya pili",
    faithMaximizes: "Kadi ya Imani inaongeza pointi zako",
    johnGospelTitle: "Injili ya Yohana",
    johnGospelStats: "Sura 21 • Mistari 878 • Lugha 14",
    bibleReaderStrong: "Kisomaji cha Biblia + Strong",
    bibleReaderStrongDesc: "Kusoma kamili na kamusi ya Strong",
    johnTreasures: "Hazina za Yohana",
    johnTreasuresDesc: "Hazina za Biblia na ukweli wa kuvutia",
    quickAccessChapters: "Ufikiaji wa haraka kwa sura maarufu:",
    johnChapter1: "Utangulizi",
    johnChapter3: "Kuzaliwa upya",
    johnChapter14: "Mimi ni njia",
    johnChapter20: "Ufufuo",
    version: "Toleo",
    madeWithLove: "Imeundwa kwa upendo kwa utukufu wa Mungu",
    backToMenu: "Rudi kwenye menyu"
  },
  
  bible: {
    readerTitle: "📖 Kisomaji cha Biblia",
    johnReaderTitle: "Kisomaji cha Biblia - Injili ya Yohana",
    john: "Yohana",
    loading: "Inapakia Maandiko...",
    loadingChapter: "Sura ya {chapter} ya Injili ya Yohana. Data kamili inapakiwa...",
    exploreWhileLoading: "Wakati huo, unaweza kuchunguza sura nyingine au kutumia kipengele cha utafutaji.",
    menu: "Menyu",
    tabBible: "Biblia",
    tabUnity: "Umoja",
    strong: "Strong",
    strongReferences: "Marejeleo ya Strong",
    verses: "aya",
    previous: "Iliyotangulia",
    next: "Inayofuata",
    strongDefinition: "Rejeleo la Strong",
    word: "Neno la asili",
    transliteration: "Tafsiri ya herufi",
    pronunciation: "Matamshi",
    meaning: "Maana",
    definition: "Ufafanuzi kamili",
    usage: "Matumizi ya Biblia",
    etymology: "Asili ya neno",
    close: "Funga",
    moreReferences: "na marejeleo mengine {{count}}",
    copyright: "📖 Louis Segond 1910 - Kikoa cha umma • Nambari za Strong zimejumuishwa",
    shareVerse: "Shiriki aya hii",
    markAsRead: "Kifungu kimesomwa",
    alreadyRead: "Tayari imesomwa",
    readingBonus: "Bonasi ya kusoma",
    results: "matokeo",
    result: "tokeo",
    copy: "Nakili",
    image: "Picha"
  },
  
  mountain: {
    spiritualAscension: "Kupanda kwa kiroho",
    levelProgress: "Ngazi {{level}} • nyota {{stars}} zimepatikana",
    combo: "Combo",
    perfectMessage: '"Kwa maana mawazo yangu si mawazo yenu" - Mwana-kondoo anapanda kuelekea hekima kamilifu',
    goodMessage: '"Tafuteni nanyi mtapata" - Kupanda kunaendelea kuelekea ukweli',
    startMessage: '"Imani, hata ndogo kama mbegu ya haradali" - Hatua ya kwanza kuelekea mwanga',
    skipAnimation: "Ruka uhuishaji",
    chapter: "Sura",
    chapterProgress: "Sura {{current}}/{{total}}",
    secret: "Siri",
    waypoints: {
      start: "Mwanzo",
      firstSlope: "Mteremko wa kwanza",
      lastSlope: "Mteremko wa mwisho"
    },
    status: {
      defeat: "Kushindwa",
      inProgress: "Inaendelea"
    }
  },
  
  bibleResources: {
    inAppReader: {
      name: "Soma kwenye App",
      description: "Msomaji wa Biblia uliojumuishwa na Strong",
      features: {
        offline: "Bila mtandao",
        strong: "Nambari za Strong",
        navigation: "Urambazaji"
      }
    }
  },
  
  quotes: {
    wisdom: "Maarifa ya kweli yanaongoza kwa hekima ya milele",
    faith: "Naweza mambo yote katika Yeye anayenitia nguvu",
    hope: "Bwana ni mchungaji wangu, sitapungukiwa na kitu",
    love: "Kwa maana Mungu aliupenda ulimwengu hivi...",
    perseverance: "Imani inahitaji uvumilivu",
    defeat: "Kushindwa kunaalikia ukuaji katika maarifa"
  },

  unity: unityTranslations,

  philosophy: {
    title: "Kipengele cha falsafa",
    loveOntology: "Upendo kama kanuni ya ontolojia",
    loveDescription: "Yesu anabadilisha upendo kuwa msingi wa metafizikia: kupenda Mungu na wengine kunakuwa muundo halisi wa kuwepo halisi. Upendo unapita maadili kuwa njia ya kuishi.",
    newCommandment: "Amri mpya",
    jesusEmphasizes: "Wakati Yesu anatoa amri mpya, anasisitiza kitenzi cha kupenda",
    loveGod: "Mpende Mungu wako kwa moyo wako wote",
    loveNeighbor: "Mpende jirani yako kama unavyojipenda mwenyewe",
    lovePriority: "Upendo unakuwa kipaumbele"
  },

  footer: {
    version: "Toleo 1.0 • 2024",
    dedication: "Imeundwa kwa utukufu wa Mungu"
  },

  endCredits: {
    lines: [
      { text: "Umefika juu ya mlima", delay: 2000 },
      { text: "Umejifunza mambo mengi", delay: 2000 },
      { text: "Imani yako inakua kila siku", delay: 2000 },
      { text: "Unapata mambo mazuri na Mungu", delay: 2000 },
      { text: "Matatizo yanakusaidia kukua", delay: 2000 },
      { text: "Yanaonyesha kile kinachofaa", delay: 2000 },
      { text: "Kuwa mnyenyekevu kama mtoto mdogo", delay: 2000 },
      { text: "Mungu anapenda moyo wako rahisi", delay: 2000 },
      { text: "Katika utulivu unasikia Mungu", delay: 2000 },
      { text: "Kufunga kunaweka roho yako huru", delay: 2000 },
      { text: "Ombea na Mungu atakuongoza", delay: 2000 },
      { text: "Kiburi kinaficha ukweli", delay: 2000 },
      { text: "Neema ya Mungu ni ya ajabu", delay: 2000 },
      { text: "Inatoka moyoni mwa Mungu", delay: 2000 },
      { text: "Imani ya kweli inakufanya huru", delay: 2000 },
      { text: "Inakuunganisha na Mungu milele", delay: 2000 },
      { text: "Upendo unaweza kubadilisha kila kitu", delay: 2000 },
      { text: "Unaweza kufanya miujiza", delay: 2000 },
      { text: "Rudia pamoja nami", delay: 2000 },
      { text: "Yesu, ninakupa moyo wangu", delay: 3000 },
      { text: "Wewe ni mfalme wangu, mwokozi wangu", delay: 3000 },
      { text: "Njoo ubadilishe maisha yangu", delay: 3000 },
      { text: "Safari inaendelea sasa", delay: 2000 },
      { text: "Shiriki mwanga huu mzuri", delay: 2000 },
      { text: "Kuelekea maisha yasiyo na mwisho", delay: 2000 },
      { text: "Weka upendo moyoni mwako", delay: 3000 },
      { text: "Kama hazina ya thamani", delay: 3000 }
    ],
    finalMessages: {
      congratulations: "HONGERA!",
      proud: "TUNAJIVUNIA WEWE",
      courage: "SHUJAA JASIRI",
      peace: "MCHUKUZI WA AMANI",
      child: "MTOTO WA MUNGU",
      blessing: "MUNGU AKUBARIKI",
      continue: "Endelea"
    }
  },

  validation: {
    pseudoTooShort: "Jina la utani lazima liwe na angalau herufi 2",
    enterPseudo: "Tafadhali weka jina la utani"
  },

  pseudoSetup: {
    title: "Chagua jina lako la utani la mchezaji",
    confirm: "Thibitisha jina la utani"
  },

  navigation: {
    back: "Rudi"
  },

  console: {
    starsUnlocked: "nyota zimefikwa! Kufungua sura",
    defeatAnimation: "Kushindwa... J.C. anarudi chini"
  },

  errors: {
    progressionError: "Kosa la maendeleo",
    invalidProgressionData: "Data ya maendeleo si sahihi:"
  },

  levels: {
    chaptersAndBonus: "Sura 8 + ngazi ya ziada",
    bonusUnlocked: "🏆 NGAZI YA ZIADA IMEFUNGULIWA! Umefikia ukamilifu wa kiroho!",
    starsToDiscover: "{stars} 273 za kugundua",
    starsPerLevel: "{stars} 3 kwa kila ngazi"
  },

  architecture: {
    title: "🔧 Usanifu wa kiufundi",
    react: {
      name: "React",
      description: "Kiolesura cha kisasa"
    },
    modules: {
      name: "Moduli",
      description: "Upakiaji wenye nguvu"
    },
    localStorage: {
      name: "LocalStorage",
      description: "Uhifadhi wa ndani"
    },
    tailwind: {
      name: "Tailwind",
      description: "Muundo unaobadilika"
    }
  },

  gameManager: {
    title: "Kuhifadhi mchezo",
    saveLocal: "Uhifadhi wa ndani",
    saveCloud: "Usawazishaji wa wingu",
    saveWaiting: "Inasubiri muunganisho",
    lastSave: "Uhifadhi wa mwisho:",
    never: "Kamwe",
    saving: "Inahifadhi...",
    save: "Hifadhi",
    loadProgress: "Pakia",
    loading: "Inapakia...",
    autoSaveEnabled: "💾 Uhifadhi wa kiotomatiki umewashwa",
    saveError: "❌ Kosa la uhifadhi",
    gameSaved: "✅ Mchezo umehifadhiwa!",
    gameLoaded: "📥 Mchezo umepakiwa!"
  }
};

export default uiTranslations;
